<script>
import vSelect from "vue-select";
export default {
  components: {
    "v-select": vSelect,
  },
  name: "subject-topics-list",
  data() {
    return {
      selected: {},
      questoinQty: 15,
    };
  },
  methods: {
    toggle(id) {
      // this.selected = { ...this.selected, [id]: !this.selected[id] };
    },
  },
};
</script>
